module.exports = __webpack_public_path__ + "static/media/approved-charts.f5fb0aa8.png";